import { useEffect } from 'react';
import { useKeyPress } from '../../../Shared/UseKeyPress';

const useCanvasHideFindings = (hideFindings: () => void) => {
  const zero = useKeyPress('0', true);

  useEffect(() => {
    if (zero) {
      hideFindings();
    }
  }, [hideFindings, zero]);
};

export default useCanvasHideFindings;
